import React from 'react';
import { css } from 'emotion';
import newPolicyUrl from '../../assets/newPolicy.png';

const containerStyle = css`
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.5);
  min-width: 23.125rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  cursor: pointer;
  @media (max-width: 767px) {
    min-width: 100%;
  }
  &:hover {
    box-shadow: 0 8px 40px rgba(64, 64, 66, 0.08);
  }
`;

const openContainerStyle = css`
  border-radius: 8px;
  background: var(--white);
  min-width: 23.125rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem 0.5rem 1.5rem;
  align-self: stretch;
  cursor: pointer;
  height: fit-content;
  @media (max-width: 767px) {
    min-width: 100%;
  }
  &:hover {
    box-shadow: 0 8px 40px rgba(64, 64, 66, 0.08);
  }
`;

const textStyle = css`
  font-weight: bold;
  font-size: 1.125rem;
  line-height: 1.2em;
  text-align: center;
  letter-spacing: -0.03em;
  color: var(--darkGray);
`;

const imgStyle = css`
  height: 2rem;
  margin-bottom: 0.5rem;
`;

const closeIconStyle = css`
  height: 1rem;
  margin-top: 1.25rem;
`;

const headerContainer = css`
  display: flex;
  justify-content: flex-end;
`;

const rowStyle = css`
  display: flex;

  font-weight: bold;
  font-size: 1rem;
  line-height: 1.1875rem;
  letter-spacing: -0.03em;
  color: var(--dark);
  margin-bottom: 1rem;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  &:hover .linkTextStyle:after {
    opacity: 1;
    width: 100%;
  }
  &:visited {
    color: var(--dark);
  }
`;

const logoStyle = css`
  width: 2.5rem;
  height: 1rem;
  margin-right: 0.75rem;
`;

const linkTextStyle = css`
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: -3px;
    height: 2px;
    left: 50%;
    width: 0;
    opacity: 0;
    background: var(--primaryBrand);
    transform: translateX(-50%);
    transition: width 0.25s, opacity 0.25s;
  }
`;

export const NewPolicyCard = ({ quote }) => {

  return (
    <div className={containerStyle} onClick={() => window.location.href = 'https://www.insyncinsurance.co.uk/get-a-quote/'}>
      <img src={newPolicyUrl} alt="newPolicy" className={imgStyle} />
      <div className={textStyle}>{quote ? 'New Quote' : 'New Policy'}</div>
    </div>
  );
};
